/* global google */

const $ = window.jQuery;

/**
 * Locations is a map component
 */
class Locations {
  /**
   * Set needed variables
   */
  constructor(map, locations, directions) {
    this.map = map;
    this.locations = locations;
    this.directions = directions;
  }

  /**
   * Run all necessary functions
   */
  init() {
    this.postalCodeField = $('#txtPostalCode');
    this.cityField = $('#txtCity');
    this.fromAddressField = $('input.from-address');
    this.radiusField = $('#ddlRadius');

    this.geocoder = new google.maps.Geocoder();

    this.gMap = new google.maps.Map(this.map, {
      center: new google.maps.LatLng(52.32863, 5.29541),
      zoom: 7,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    this.includeDirections = this.directions && this.directions.length;

    if (this.includeDirections) {
      this.directionsService = new google.maps.DirectionsService();
      this.directionsDisplay = new google.maps.DirectionsRenderer();

      this.directionsDisplay.setPanel(this.directions.get(0));
      this.directionsDisplay.setMap(this.gMap);
    }

    this.savedFromAddress = '';
    this.selectedMarker = null;
    this.radiusShape = null;

    this.setMarkers();
    this.filterLocations();

    $(document).on('click', '.route-link', (e) => { Locations.onRouteLinkClick(e); });
    $(document).on('click', '.show-route', (e) => { this.onShowRoute(e); });
    
    $('.form-locations input:checkbox').on('click', () => { this.filterLocations(); });
    $('#btnLocationsSearch').on('click', () => { this.onSearch(); });
  }

  setMarkers() {
    for (let x = 0; x < this.locations.length; x += 1) {
      const location = this.locations[x];
      const marker = this.createMarker(location);
      const infoWindow = Locations.createInfoWindow(location);

      marker.attachedInfoWindow = infoWindow;
      marker.location = location;

      google.maps.event.addListener(marker, 'click', () => { this.onMarkerClick(marker); });

      location.marker = marker;
      location.visible = $('.checklist input[data-typeid]:checked').length === 0
        || $(`.checklist input[data-typeid='${location.locationTypeId}']`).get(0).checked;
    }
  }

  createMarker(location) {
    const point = new google.maps.LatLng(location.latitude, location.longitude);

    const marker = new google.maps.Marker({
      position: point,
      map: this.gMap,
      icon: `//maps.google.com/mapfiles/ms/icons/${location.markerColor}-dot.png`,
    });

    return marker;
  }

  onMarkerClick(marker) {
    this.selectedMarker = marker;
    
    this.gMap.setCenter(this.selectedMarker.position);
    this.selectedMarker.attachedInfoWindow.open(this.gMap, this.selectedMarker);

    this.fromAddressField.val(this.savedFromAddress);

    $('input.from-address').val(this.savedFromAddress);
  }

  onShowRoute(e) {
    e.preventDefault();

    const fromAddress = $(e.currentTarget).prev().val();
    this.savedFromAddress = fromAddress;

    this.showDirections(fromAddress);
  }

  filterLocations() {
    /* eslint-disable no-param-reassign,max-len */
    const selectedTypes = [];
    const onlyShowRedMarkers = document.querySelector('#gpgroot-locations-filter').checked;

    $('.locations.checklist input[type="checkbox"]:checked').each((idx, item) => {
      selectedTypes.push($(item).data('type-id'));
    });

    this.locations.forEach((location) => {
      if (
        (selectedTypes === null || selectedTypes.length === 0 || selectedTypes.includes(location.locationTypeId))
        && ((onlyShowRedMarkers && location.markerColor === 'red') || !onlyShowRedMarkers)
      ) {
        location.visible = true;
      } else {
        location.visible = false;
      }
    });

    this.showMap(false);
  }

  onSearch() {
    if (!this.geocoder) {
      return false;
    }

    const toAddress = this.getToAddress();
    
    if (toAddress === ', NL') {
      return false;
    }

    this.geocoder.geocode({ address: toAddress },
      (results, status) => { this.onGeocodeResponse(results, status); });

    return false;
  }

  onGeocodeResponse(results, status) {
    if (status !== google.maps.GeocoderStatus.OK) {
      /* eslint-disable no-alert */
      alert('Google Maps kan de locatie van uw zoekcriteria niet vinden.');
    } else {
      const selectedRadius = parseFloat(this.radiusField.val());
      const determinedLocation = results[0].geometry.location;

      this.gMap.setCenter(determinedLocation);

      if (selectedRadius <= 10000) {
        this.gMap.setZoom(11);
      } else if (selectedRadius <= 25000) {
        this.gMap.setZoom(9);
      } else {
        this.gMap.setZoom(8);
      }

      if (this.radiusShape !== null && this.radiusShape !== undefined) {
        this.radiusShape.setMap(null);
      }

      const shapeOptions = {
        center: determinedLocation,
        radius: selectedRadius,
        fillColor: '#f00',
        fillOpacity: 0.1,
        strokeColor: '',
        strokeOpacity: 0.5,
        map: this.gMap,
      };

      this.radiusShape = new google.maps.Circle(shapeOptions);
    }
  }

  getToAddress() {
    const pc = this.postalCodeField.val();
    const city = this.cityField.val();

    let toAddress = pc || '';

    if (city) {
      toAddress = `${toAddress}, ${city}`;
    }

    toAddress = `${toAddress}, NL`;

    return toAddress;
  }

  showMap(resetCenter) {
    let point;
    this.clearOverlays();

    for (let i = 0; i < this.locations.length; i += 1) {
      const location = this.locations[i];
      if (location.visible) {
        location.marker.setMap(this.gMap);
        point = location.marker.position;
      }
    }
    if (resetCenter && point) {
      this.gMap.setCenter(point, 11);
      this.selectedMarker = null;
    }
  }

  clearOverlays() {
    for (let i = 0; i < this.locations.length; i += 1) {
      const location = this.locations[i];
      if (!location.visible) {
        location.marker.setMap(null);
      }
    }
  }

  showDirections(fromAddress) {
    this.selectedMarker.attachedInfoWindow.close();

    const loc = this.selectedMarker.location;

    const fullDestinationAddress = `${loc.address}, ${loc.postalCode}, ${loc.city}`;

    this.directionsService.route({
      origin: fromAddress,
      destination: fullDestinationAddress,
      travelMode: google.maps.DirectionsTravelMode.DRIVING,
    }, (result, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        this.directionsDisplay.setDirections(result);
      }
    });
  }

  static createInfoWindow(location) {
    const postalCodeAndCity = this.htmlLine(`${location.postalCode} ${location.city}`);
    let locationTypes = '';

    if (location.locationTypes) {
      locationTypes = `<br><small class="text-primary">${location.locationTypes}</small><br>`;
    }
  

    const infoWindow = new google.maps.InfoWindow({
      content: `<strong>${location.name}</strong>
        <p>
          ${this.htmlLine(location.address)}
          ${postalCodeAndCity}
          ${locationTypes}
          ${this.htmlLine(location.phone)}
          ${this.htmlLine(location.hours, '<br/>Openingstijden:<br />')}
        </p>
        <a href="#" class="route-link">Routebeschrijving</a>
        <div class="route-details">
          <span>Vanaf</span><input type="text" class="from-address" />
          <input type="button" value="toon route" class="show-route" />
        </div>`,
    });

    return infoWindow;
  }

  static htmlLine(text, prefix) {
    const useText = text || '';

    let usePrefix = prefix || '';
    usePrefix = useText ? usePrefix : '';

    const postFix = useText ? '<br />' : '';

    const line = `${usePrefix}${useText}${postFix}`;

    return line;
  }

  static onRouteLinkClick(e) {
    e.preventDefault();
    const target = $(e.currentTarget);

    target.next().css('visibility', 'visible');
    target.next().children('input[type="text"]').focus();
    target.hide();
  }
}

$(document).ready(() => {
  const maps = $('#locations-map');
  const directions = $('#directions');
  const locs = global.locations;

  if (maps && maps.length && locs && locs.length) {
    const component = new Locations(maps.get(0), locs, directions);
    component.init();
  }
});
